/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { Injectable } from '@angular/core';
import { CanMatch } from '@angular/router';
import { EControlZonePermissions } from '@midas/shared/common';
import { UserPermissionsService } from '@midas/shared/data-access';
import { map, Observable, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OverviewActionsGuard implements CanMatch {
  constructor(private userPermissionsService: UserPermissionsService) {}

  canMatch(): Observable<boolean> {
    return this.userPermissionsService
      .checkUserPermissionsForControlZone(EControlZonePermissions.CanViewCallToAction)
      .pipe(
        take(1),
        map((result) => result),
      );
  }
}
